import { Link } from "react-router-dom";
import useBasePath from "files/hooks/useBasePath";
import { LlamaIcon } from "~/assets/icons";
import { Button } from "~/components/ui/button";

/**
 * Shadcn rebuild of `files/components/FileNotFound`, for the
 * nextgen-embedded Files tab only.
 */
export const EmbeddedFileNotFound = () => {
  const basePath = useBasePath();
  return (
    <div className="flex min-h-[300px] flex-col items-center justify-center gap-3 rounded-lg border border-border bg-background p-6 text-center">
      <LlamaIcon
        opacity={0.4}
        width={50}
        className="text-primary"
        transform="matrix(-1, 0, 0, 1, 0, 0), scale(1.2)"
      />
      <p className="text-sm">File not found</p>
      <Button asChild>
        <Link to={basePath}>Back to top directory</Link>
      </Button>
    </div>
  );
};
